import type { ReadonlyDeep } from 'type-fest';

import { OrganizationMembershipInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

export function organizationMembershipForm2ApiMapper(
  organizationMembership: Readonly<OrganizationMembershipInput>,
): ReadonlyDeep<OrganizationMembershipInput> {
  return pruneInput(organizationMembership, OrganizationMembershipInput);
}
